import Vue from 'vue';
import Alert from '@/components/alert.vue';

// 用于创建和控制 Alert 的构造函数
const AlertConstructor = Vue.extend(Alert);

let alertInstance = null;

const alertPlugin = {
	install(Vue) {
		// 在 Vue.prototype 上添加一个全局方法 $alert
		Vue.prototype.$alert = (message) => {
			if (!alertInstance) {
				// 创建一个 Alert 实例并挂载到 DOM 上
				alertInstance = new AlertConstructor({
					el: document.createElement('div'),
					data: {
						message: message, // 传递消息
						isShow: true // 显示组件
					},
				});

				// 将实例添加到 body 中
				document.body.appendChild(alertInstance.$el);
			} else {
				// 如果实例已存在，更新消息
				alertInstance.message = message;
				alertInstance.startTimer();
			}
		}
	}
}

export default alertPlugin;